module.exports = __webpack_public_path__ + "static/media/US-Army.694b4ce9.svg";